import variables from '../../styles/variables.module.scss';
import caseimg from '../../assets/cases/mevia-caseimg.jpg';

export default {
  path: '/cases/mevia',
  color: variables.mevia,
  case: { fall: caseimg },
  title: 'Mevia',
  description: 'Mevia helps solve the issue of medication errors and missed doses',
  headline: 'iOS & Android application',
  isAndroid: false,
  isWeb: false,
};
